import {
	CalcType,
	Constant,
	FormField,
	Formula,
	MoveDirection,
	Operation,
	Parameter,
	Rule,
	RuleTest,
	SaveRes,
	Variable,
} from 'api';
import * as actions from './actionTypes';

// import saga
export const setCalcType = (calcType: CalcType) => ({
	type: actions.SET_CALC_TYPE,
	payload: calcType,
});

export const getRules = (calcType: CalcType) => ({
	type: actions.GET_RULES,
	payload: calcType,
});
export const setRules = (rules: Array<Rule>) => ({
	type: actions.SET_RULES,
	payload: rules,
});

export const getFormulae = (ruleId: number) => ({
	type: actions.GET_FORMULAE,
	payload: ruleId,
});
export const setFormulae = (formulae: Array<Formula>) => ({
	type: actions.SET_FORMULAE,
	payload: formulae,
});

export const getRule = (ruleId: number) => ({
	type: actions.GET_RULE,
	payload: ruleId,
});
export const setRule = (rule: Rule | null) => ({
	type: actions.SET_RULE,
	payload: rule,
});

export const getParams = (calcType: CalcType) => ({
	type: actions.GET_PARAMETERS,
	payload: calcType,
});
export const setParams = (params: Array<Parameter>) => ({
	type: actions.SET_PARAMETERS,
	payload: params,
});

export const getFormFields = (calcType: CalcType) => ({
	type: actions.GET_FORM_FIELDS,
	payload: calcType ,
});

export const setFormFields = (res: Array<FormField>) => ({
	type: actions.SET_FORM_FIELDS,
	payload: res,
});

export const getOperations = () => ({
	type: actions.GET_OPERATIONS,
});
export const setOperations = (operations: Array<Operation>) => ({
	type: actions.SET_OPERATIONS,
	payload: operations,
});

export const getVariables = (calcType: CalcType) => ({
	type: actions.GET_VARIABLES,
	payload: calcType,
});
export const setVariables = (variables: Array<Variable>) => ({
	type: actions.SET_VARIABLES,
	payload: variables,
});

export const getConstants = () => ({
	type: actions.GET_CONSTANTS,
});

export const setConstants = (constants: Array<Constant>) => ({
	type: actions.SET_CONSTANTS,
	payload: constants,
});

export const setConstValue = (constant: Constant) => ({
	type: actions.SET_CONST_VALUE,
	payload: constant,
});

export const saveConstant = (constant: Constant) => ({
	type: actions.SAVE_CONSTANT,
	payload: constant,
});

export const updateConstant = (constant: Constant) => ({
	type: actions.UPDATE_CONSTANT,
	payload: constant,
});

export const getDefinitions = (ruleId: number) => ({
	type: actions.GET_FORMULAE_DEFS,
	payload: ruleId,
});
export const setDefinitions = (defs: Array<Formula>) => ({
	type: actions.SET_FORMULAE_DEFS,
	payload: defs,
});

export const saveRule = (rule: Rule) => ({
	type: actions.SAVE_RULE,
	payload: rule,
});

export const copyRule = (ruleId: number, calcType: CalcType, name: string) => ({
	type: actions.COPY_RULE,
	payload: {
		ruleId,
		calcType,
		name,
	},
});

export const savedRule = (res: SaveRes) => ({
	type: actions.SAVED_RULE,
	payload: res,
});

export const updateRule = (ruleId: number, rule: Rule) => ({
	type: actions.UPDATE_RULE,
	payload: {
		id: ruleId,
		rule,
	},
});

export const updatedRule = (res: SaveRes) => ({
	type: actions.UPDATED_RULE,
	payload: res,
});

export const testRule = (rule: Rule) => ({
	type: actions.TEST_RULE,
	payload: rule,
});

export const testedRule = (test: RuleTest) => ({
	type: actions.TESTED_RULE,
	payload: test,
});

export const getFormula = (formulaId: number) => ({
	type: actions.GET_FORMULA,
	payload: formulaId,
});
export const setFormula = (formula: Formula) => ({
	type: actions.SET_FORMULA,
	payload: formula,
});

export const saveFormula = (ruleId: number, formula: Formula) => ({
	type: actions.SAVE_FORMULA,
	payload: {
		id: ruleId,
		formula,
	},
});

export const updateFormula = (ruleId: number, formula: Formula) => ({
	type: actions.UPDATE_FORMULA,
	payload: {
		id: ruleId,
		formula,
	},
});

export const deleteFormula = (formulaId: number, ruleId: number) => ({
	type: actions.DELETE_FORMULA,
	payload: {
		ruleId,
		formulaId,
	},
});

export const moveFormula = (
	formulaId: number,
	ruleId: number,
	direction: MoveDirection
) => ({
	type: actions.MOVE_FORMULA,
	payload: {
		formulaId,
		ruleId,
		direction,
	},
});

export const moveRule = (
	ruleId: number,
	direction: MoveDirection,
	calcType: CalcType
) => ({
	type: actions.MOVE_RULE,
	payload: {
		ruleId,
		direction,
		calcType,
	},
});

export const deleteRule = (ruleId: number, calcType: CalcType) => ({
	type: actions.DELETE_RULE,
	payload: {
		id: ruleId,
		calcType,
	},
});

export const deletedRule = (res: SaveRes) => ({
	type: actions.DELETED_RULE,
	payload: res,
});

export const saveError = (error: string) => ({
	type: actions.RULE_ERROR,
	payload: error,
});

export const testError = (progress: boolean) => ({
	type: actions.TEST_ERROR,
	payload: progress,
});

export const setConstantId = (id: number | null) => ({
	type: actions.SET_CONSTANT_ID,
	payload: id,
});

export const removeConstantId = () => ({
	type: actions.REMOVE_CONSTANT_ID,
});

export const deleteConstant = (constantId: number) => ({
	type: actions.DELETE_CONSTANT,
	payload: { constantId },
});

export const deletedConstant = (res: SaveRes) => ({
	type: actions.DELETED_CONSTANT,
	payload: res,
});
